// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__wJFjU","footer":"ModalCreateQualiphyProcedure_footer__2JZTb","additionData":"ModalCreateQualiphyProcedure_additionData__saoKZ"};